import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      marginTop: '3rem'
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    button: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    arrowContainer: {
      width: '0.6rem',
      marginRight: '0.5rem'
    },
    homeContainer: {
      width: '0.9rem',
      marginRight: '0.5rem'
    },
    text: {
      display: 'inline-block'
    },
    box: {
      marginBottom: '3rem',
      '& a': {
        textDecoration: 'none',
        color: colors.mainFont
      }
    }
  })
)
